import { Button, MenuItem, Popover, TextField } from "@material-ui/core";
import { getRequest } from "api/apiCaller";
import AutocompleteSubOrg from "components/autocomplete/AutocompleteSubOrg";
import API_URL from "constant/api-url";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import classes from "pages/agent-chat-ticket/AgentChatTicket.module.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  type: Yup.string().required("Không được trống"),
  subOrg: Yup.object().shape({
    code: Yup.string().required("Không được trống"),
  }),
});

const PopupAddNewChat = () => {
  const { ringmeOttSdk } = useSelector((state) => state.ringmeOttSdk);
  const [anchorEl, setAnchorEl] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const [whereSubOrg, setWhereSubOrg] = useState();

  const handleOpenPopUpAddNewChat = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClosePopUpAddNewChat = () => {
    setAnchorEl(null);
  };

  const handleSubmit = async (values) => {
    try {
      if (!ringmeOttSdk) {
        throw new Error("Chưa đăng nhập Chat SDK");
      }
      const res = await getRequest(API_URL.DEPARTMENT_QUEUE, {
        type: values.type,
        code: values.subOrg.code,
      });

      if (res.data.queueId) {
        let queueInfo = {
          idQueue: values.subOrg.code,
          dispName: values.subOrg.name,
          jidQueue: res.data.queueId,
          typeQueue: values.type === 5 ? "CSKH" : "Bưu cục",
        };

        ringmeOttSdk.openChatQueue(JSON.stringify(queueInfo), null, 0);
        handleClosePopUpAddNewChat();
      } else {
        throw new Error("Không tồn tại đối tượng chat");
      }
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
    }
  };

  const formAddNewChat = useFormik({
    initialValues: {
      type: "",
      subOrg: {},
    },
    onSubmit: handleSubmit,
    validationSchema,
  });

  return (
    <div>
      <div className={`${classes.label}`}>
        Thêm cuộc chat mới
        <span
          className={classes.newChatIcon}
          onClick={handleOpenPopUpAddNewChat}>
          <i className="fas fa-user-plus"></i>
        </span>
      </div>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClosePopUpAddNewChat}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        classes={{
          paper: classes.newChatWrapper,
        }}>
        <form onSubmit={formAddNewChat.handleSubmit}>
          <div className={classes.newChatHeader}>
            <span
              className={classes.newChatCloseIcon}
              onClick={handleClosePopUpAddNewChat}>
              Hủy bỏ
            </span>
            <span>Tin nhắn mới</span>
          </div>

          <div className={classes.newChatContent}>
            <div className={classes.label}>Chọn bộ phận</div>
            <TextField
              variant="outlined"
              InputProps={{
                classes: {
                  input: classes.input,
                },
              }}
              select
              fullWidth
              {...formAddNewChat.getFieldProps("type")}
              error={
                formAddNewChat.touched.type &&
                Boolean(formAddNewChat.errors.type)
              }
              helperText={
                formAddNewChat.touched.type && formAddNewChat.errors.type
              }
              onChange={(e) => {
                formAddNewChat.setFieldValue("type", e.target.value);
                formAddNewChat.setFieldValue("subOrg", {});
                setWhereSubOrg({ isCskh: e.target.value === 5 });
              }}>
              <MenuItem value={5} classes={{ root: classes.input }}>
                CSKH
              </MenuItem>
              <MenuItem value={1} classes={{ root: classes.input }}>
                Bưu cục thu
              </MenuItem>
              <MenuItem value={2} classes={{ root: classes.input }}>
                Bưu cục phát
              </MenuItem>
            </TextField>

            <div className={classes.label} style={{ marginTop: 10 }}>
              Chọn đơn vị
            </div>
            <AutocompleteSubOrg
              onChangeValue={(item) =>
                formAddNewChat.setFieldValue("subOrg", item)
              }
              value={formAddNewChat.values.subOrg}
              isVisibleAllOption={false}
              label=""
              InputProps={{
                classes: {
                  input: classes.input,
                },
              }}
              query="all"
              where={whereSubOrg}
              error={
                formAddNewChat.touched.subOrg &&
                Boolean(formAddNewChat.errors.subOrg)
              }
              helperText={
                formAddNewChat.touched.subOrg &&
                formAddNewChat.errors.subOrg?.code
              }
            />
            <div className={classes.newChatFooter}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                type="submit"
                disabled={
                  formAddNewChat.isSubmitting || !formAddNewChat.isValid
                }>
                Bắt đầu trò chuyện
              </Button>
            </div>
          </div>
        </form>
      </Popover>
    </div>
  );
};

export default PopupAddNewChat;
